export default __webpack_public_path__ + "static/media/IconTwoPeople.6ca99bb2.svg";